import { render, staticRenderFns } from "./UploadFileWidget.vue?vue&type=template&id=6bbf48c8&scoped=true"
import script from "./UploadFileWidget.vue?vue&type=script&lang=js"
export * from "./UploadFileWidget.vue?vue&type=script&lang=js"
import style0 from "./UploadFileWidget.vue?vue&type=style&index=0&id=6bbf48c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbf48c8",
  null
  
)

export default component.exports